import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoryPageStatsQueryVariables = Types.Exact<{
  filter: Types.StoryPageStatsFilter;
}>;


export type StoryPageStatsQuery = { __typename?: 'RootQueryType', storyPageStats?: { __typename?: 'StoryPageStatsResult', storyPageStats: { __typename?: 'StoryPageStats', storyPage: { __typename?: 'InitiationItem', id: string, interactionType: Types.InteractionType, databaseId: any, title: string, order: number, type: Types.InitiationItemType, interaction: { __typename: 'MultipleChoiceInteraction', multipleChoiceInteractionId: string, id: string, type: Types.InteractionType, question: { __typename?: 'PageQuestion', id: string, title?: string | null, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number }> } } | { __typename: 'ShoppableInteraction', count: number, shoppableInteractionId: string, id: string, type: Types.InteractionType, shoppableProducts: Array<{ __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } }> }, content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType } | null, question?: { __typename?: 'PageQuestion', id: string, title?: string | null, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number }> } | null }, stats: { __typename?: 'BasicStoryPageStats', pageviews: number, visitDuration: number, choicesStats?: Array<{ __typename?: 'ChoiceStats', choiceId: string, choiceText: string, percentage: number, clicks: number }> | null, productsStats?: Array<{ __typename?: 'ProductStats', productId: string, percentage: number, clicks: number }> | null } } } | null };

export type StoryPageStatsStoryPageFragment = { __typename?: 'InitiationItem', id: string, interactionType: Types.InteractionType, databaseId: any, title: string, order: number, type: Types.InitiationItemType, interaction: { __typename: 'MultipleChoiceInteraction', multipleChoiceInteractionId: string, id: string, type: Types.InteractionType, question: { __typename?: 'PageQuestion', id: string, title?: string | null, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number }> } } | { __typename: 'ShoppableInteraction', count: number, shoppableInteractionId: string, id: string, type: Types.InteractionType, shoppableProducts: Array<{ __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } }> }, content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType } | null, question?: { __typename?: 'PageQuestion', id: string, title?: string | null, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number }> } | null };

export type StoryPageStatsStoryPageInteraction_MultipleChoiceInteraction_Fragment = { __typename: 'MultipleChoiceInteraction', multipleChoiceInteractionId: string, id: string, type: Types.InteractionType, question: { __typename?: 'PageQuestion', id: string, title?: string | null, choices: Array<{ __typename?: 'PageChoice', id: string, type?: Types.NextInteractionType | null, hasNext?: boolean | null, text?: string | null, value?: string | null, order: number }> } };

export type StoryPageStatsStoryPageInteraction_ShoppableInteraction_Fragment = { __typename: 'ShoppableInteraction', count: number, shoppableInteractionId: string, id: string, type: Types.InteractionType, shoppableProducts: Array<{ __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } }> };

export type StoryPageStatsStoryPageInteractionFragment = StoryPageStatsStoryPageInteraction_MultipleChoiceInteraction_Fragment | StoryPageStatsStoryPageInteraction_ShoppableInteraction_Fragment;

export type StoryPageStatsStatsFragment = { __typename?: 'BasicStoryPageStats', pageviews: number, visitDuration: number, choicesStats?: Array<{ __typename?: 'ChoiceStats', choiceId: string, choiceText: string, percentage: number, clicks: number }> | null, productsStats?: Array<{ __typename?: 'ProductStats', productId: string, percentage: number, clicks: number }> | null };

export type StoryPageStatsChoicesStatsFragment = { __typename?: 'ChoiceStats', choiceId: string, choiceText: string, percentage: number, clicks: number };

export type StoryPageStatsProductsStatsFragment = { __typename?: 'ProductStats', productId: string, percentage: number, clicks: number };

export const StoryPageStatsStoryPageInteractionFragmentDoc = gql`
    fragment StoryPageStatsStoryPageInteraction on Interaction {
  id
  type
  ... on ShoppableInteraction {
    __typename
    count
    shoppableInteractionId
    shoppableProducts {
      id
      ctaType
      product {
        id
        currencyCode
        onlineStoreUrl
        sourceType
        sourceId
        title
        images {
          id
          src
        }
        variants {
          id
          originalPrice
          price
        }
      }
    }
  }
  ... on MultipleChoiceInteraction {
    __typename
    multipleChoiceInteractionId
    question {
      id
      title
      choices {
        id
        type
        hasNext
        text
        value
        order
      }
    }
  }
}
    `;
export const StoryPageStatsStoryPageFragmentDoc = gql`
    fragment StoryPageStatsStoryPage on InitiationItem {
  id
  interactionType
  databaseId
  title
  order
  type
  interaction {
    ...StoryPageStatsStoryPageInteraction
  }
  content {
    id
    type
    groupType
  }
  question {
    id
    title
    choices {
      id
      type
      hasNext
      text
      value
      order
    }
  }
}
    ${StoryPageStatsStoryPageInteractionFragmentDoc}`;
export const StoryPageStatsChoicesStatsFragmentDoc = gql`
    fragment StoryPageStatsChoicesStats on ChoiceStats {
  choiceId
  choiceText
  percentage
  clicks
}
    `;
export const StoryPageStatsProductsStatsFragmentDoc = gql`
    fragment StoryPageStatsProductsStats on ProductStats {
  productId
  percentage
  clicks
}
    `;
export const StoryPageStatsStatsFragmentDoc = gql`
    fragment StoryPageStatsStats on BasicStoryPageStats {
  pageviews
  visitDuration
  choicesStats {
    ...StoryPageStatsChoicesStats
  }
  productsStats {
    ...StoryPageStatsProductsStats
  }
}
    ${StoryPageStatsChoicesStatsFragmentDoc}
${StoryPageStatsProductsStatsFragmentDoc}`;
export const StoryPageStatsDocument = gql`
    query storyPageStats($filter: StoryPageStatsFilter!) {
  storyPageStats(filter: $filter) {
    storyPageStats {
      storyPage {
        ...StoryPageStatsStoryPage
      }
      stats {
        ...StoryPageStatsStats
      }
    }
  }
}
    ${StoryPageStatsStoryPageFragmentDoc}
${StoryPageStatsStatsFragmentDoc}`;

/**
 * __useStoryPageStatsQuery__
 *
 * To run a query within a React component, call `useStoryPageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryPageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryPageStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStoryPageStatsQuery(baseOptions: Apollo.QueryHookOptions<StoryPageStatsQuery, StoryPageStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoryPageStatsQuery, StoryPageStatsQueryVariables>(StoryPageStatsDocument, options);
      }
export function useStoryPageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoryPageStatsQuery, StoryPageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoryPageStatsQuery, StoryPageStatsQueryVariables>(StoryPageStatsDocument, options);
        }
export type StoryPageStatsQueryHookResult = ReturnType<typeof useStoryPageStatsQuery>;
export type StoryPageStatsLazyQueryHookResult = ReturnType<typeof useStoryPageStatsLazyQuery>;
export type StoryPageStatsQueryResult = Apollo.QueryResult<StoryPageStatsQuery, StoryPageStatsQueryVariables>;
export function refetchStoryPageStatsQuery(variables: StoryPageStatsQueryVariables) {
      return { query: StoryPageStatsDocument, variables: variables }
    }